import m from 'mithril';

export default {
  oninit({ state, attrs }) {
    state.id = Math.random().toString().split('.')[1];
  },
  oncreate({ state, attrs }) {
    $(`#${state.id}`).daterangepicker({
      buttonClasses: 'btn btn-sm',
      applyClass: 'btn-primary',
      cancelClass: 'btn-secondary',
      startDate: attrs.start,
      endDate: attrs.end,
    }, (start, end, label) => {
      attrs.select({
        start, end,
      });
      $(`#${state.id} .form-control`).val(`${start.format('YYYY-MM-DD') } / ${end.format('YYYY-MM-DD')}`);
    });
  },
  view({ state, attrs }) {
    return m("input.form-control[placeholder='Select time'][readonly=''][type='text']", { id: state.id });
  },
};
